import { createContext } from "react";
import { IAppContext } from "./interfaces/IAppContext";

export default createContext({
  scrollAnimating: false,
} as IAppContext);